












































































































































































































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import MyForm from '@/mixins/form';
import moment from 'moment';
import _ from 'lodash';
import AreaPicker from '@/components/areapicker.vue';

@Component({
  components: {
    AreaPicker,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() stadium!: any;

  @Prop() tags!: any[];

  cooperate_time_start: any = moment();

  cooperate_time_end: any = moment();

  phone_online_time: any = moment();

  order_online_time: any = moment();

  ai_online_time: any = moment();

  default_ground_price = 0;

  mounted() {
    this.cooperate_time_start = moment(
      this.stadium.stadium_info.cooperate_time_start,
      'YYYY-MM-DD HH:mm:ss',
    );
    this.cooperate_time_end = moment(
      this.stadium.stadium_info.cooperate_time_end,
      'YYYY-MM-DD HH:mm:ss',
    );
    this.phone_online_time = moment(
      this.stadium.stadium_info.phone_online_time,
      'YYYY-MM-DD HH:mm:ss',
    );
    this.order_online_time = moment(
      this.stadium.stadium_info.order_online_time,
      'YYYY-MM-DD HH:mm:ss',
    );
    this.ai_online_time = moment(
      this.stadium.stadium_info.ai_online_time,
      'YYYY-MM-DD HH:mm:ss',
    );

    this.default_ground_price = this.stadium.stadium_info.default_ground_price / 100;

    // 省市区
    const areastr: string[] = [];
    if (this.stadium.stadium_info.province_id) {
      areastr.push(this.stadium.stadium_info.province_id.toString());
    }
    if (this.stadium.stadium_info.city_id) {
      areastr.push(this.stadium.stadium_info.city_id.toString());
    }
    // console.log(res.data.stadium_info);
    if (this.stadium.stadium_info.county_id) {
      areastr.push(this.stadium.stadium_info.county_id.toString());
    }
    // console.log(areastr);
    this.stadium.stadium_info['areastr' as string] = areastr;
  }

  handleSubmit1() {
    this.form.validateFields(async (err: any, fieldsValue: any) => {
      if (!err) {
        const fieldValues = this.stadium.stadium_info;
        const values: any = {};
        const fields: string[] = [];
        // console.log(fieldValues)
        for (const key in fieldValues) {
          // console.log(key)
          // console.log(fieldValues[key])
          // console.log(typeof fieldValues[key])
          // console.log(_.isEmpty(fieldValues[key]))
          if (key !== 'areastr' && key !== 'tags') {
            const fieldValue = _.get(fieldValues, [key]);
            // console.log(key)
            fields.push(key);
            if (moment.isMoment(fieldValue)) {
              _.set(
                values,
                [key],
                moment(fieldValue).format('YYYY-MM-DD HH:mm:ss'),
              );
              // }else if(key === '')
            } else {
              _.set(values, [key], fieldValue);
            }
          }
        }

        let province_id = 0;
        let city_id = 0;
        let county_id = 0;

        // console.log(this.stadium.stadium_info.areastr)

        if (this.stadium.stadium_info.areastr.length > 2) {
          county_id = _.parseInt(this.stadium.stadium_info.areastr[2]);
        }
        if (this.stadium.stadium_info.areastr.length > 1) {
          city_id = _.parseInt(this.stadium.stadium_info.areastr[1]);
        }
        if (this.stadium.stadium_info.areastr.length > 0) {
          province_id = _.parseInt(this.stadium.stadium_info.areastr[0]);
        }

        if (province_id === 0 && city_id === 0) {
          this.$message.error('省市不能为空');
          return;
        }

        _.set(values, ['province_id'], province_id);
        _.set(values, ['city_id'], city_id);
        _.set(values, ['county_id'], county_id);

        _.set(
          values,
          ['default_ground_price'],
          this.tsMul(this.default_ground_price, 100),
        );

        await this.$store.dispatch('stadium/saveStadiumTags', {
          stadium_id: this.stadium.stadium_info.id,
          tag_ids: JSON.stringify(this.stadium.stadium_info.tags),
        });

        await this.$store.dispatch('stadium/updateWithFields', {
          stadium_id: this.stadium.stadium_info.id,
          fields,
          stadium_json: JSON.stringify(values),
        });

        this.$message.success('操作成功');
      }
    });
  }

  updateAiOnlineTime() {
    this.$confirm({
      title: '确认消息',
      content: '确定更新ai上线时间吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/updateAiOnLineTime', {
          id: this.stadiumId,
          ai_on_line_time: moment(
            String(this.stadium.stadium_info.ai_online_time),
          ).format('YYYY-MM-DD HH:mm:ss'),
        });
        if (res && res.data) {
          this.$message.success('更新成功');
        } else {
          this.$message.error('更新失败');
        }
      },
    });
  }
}
